import {LockOutlined, UserOutlined} from '@ant-design/icons'
import {Alert, Button, Form, Input} from 'antd'
import '@/pages/login/style.css'
import {loginApi} from 'common/api/entitiesApi'
import {StorageKey} from 'common/context/Storage'
import {useUserContext} from 'common/context/UserContext'
import {setLoggedUserProps} from 'common/util/Util'
import {useState} from 'react'
import {useNavigate} from 'react-router-dom'

const LoginPageAdmin = () => {
  const [form] = Form.useForm()
  const [authError, setAuthError] = useState<string | null>(null)
  const {setUser} = useUserContext()
  const navigateTo = useNavigate()

  const onFinish = async (values: any) => {
    setAuthError(null)
    loginApi.login(values.username, values.password).then(success => {
      if (success) {
        setLoggedUserProps(setUser).then(() => {
          navigateTo('/')
        })
      } else {
        setAuthError(localStorage.getItem(StorageKey.ApiError) || 'Incorrect Username or Password')
      }
    })
  }

  return (
    <div className="login-form-container">
      <Form form={form} name="login_form" onFinish={onFinish} className="login-form" layout="vertical">
        <Form.Item name="username" rules={[{required: true, message: 'Please input your username!'}]}>
          <Input prefix={<UserOutlined/>} placeholder="Username"/>
        </Form.Item>

        <Form.Item name="password" rules={[{required: true, message: 'Please input your password!'}]}>
          <Input.Password prefix={<LockOutlined/>} placeholder="Password"/>
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit" className="login-form-button" block>
            Log in
          </Button>
        </Form.Item>
        {authError ? <Alert message={authError} type="error"/> : null}
      </Form>
    </div>
  )
}

export default LoginPageAdmin
